module.exports = __webpack_public_path__ + "img/full3-min.64c4c188.png";